/*
  Animazioni di collezione, prodotto, carrello e notifica — GSAP core (nessun plugin).
  - Testata collezione: occhiello, conteggio e descrizione in dissolvenza,
    filetto che si traccia, immagine che si apre come una tenda.
  - Griglia: le card sono visibili da subito (nessun reveal d'ingresso, per non
    ritardare la visualizzazione dei prodotti); dopo il filtraggio AJAX dei facet
    reinizializzo i nodi nuovi così l'hover GSAP delle card torna attivo.
  - Pagina prodotto: la galleria si apre dal basso, la colonna informazioni
    entra a scaletta.
  - Pagina carrello: titolo, righe e riepilogo entrano a scaletta; le righe
    sostituite da cart.js all'aggiornamento restano visibili (data-taste-init).
  - Notifica di aggiunta: lo slide del pannello resta CSS (Dawn), i contenuti
    entrano a scaletta patchando open() del custom element.
  Tutto dentro gsap.matchMedia(): con prefers-reduced-motion non si muove nulla.
*/

(function () {
  if (!window.gsap) return;

  // Più sezioni possono includere questo script: eseguo una volta sola.
  if (window.__tasteShopMotion) return;
  window.__tasteShopMotion = true;

  var mm = gsap.matchMedia();

  /* ---------- Testata della collezione ---------- */

  function testata(scope) {
    var hero = scope.querySelector('[data-taste-hero]');
    if (!hero || hero.dataset.tasteInit) return;
    hero.dataset.tasteInit = 'true';

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    var dissolvenze = hero.querySelectorAll('[data-taste-fade]');
    if (dissolvenze.length) {
      tl.to(dissolvenze, { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.08, startAt: { y: 16 } }, 0.2);
    }

    var media = hero.querySelector('.taste-hero__media');
    if (media) {
      tl.to(media, { clipPath: 'inset(0% 0 0 0)', duration: 1.1 }, 0.3);
    }

    var filetto = hero.querySelector('.taste-hero__rule');
    if (filetto) {
      tl.to(filetto, { scaleX: 1, duration: 1.1, ease: 'power3.inOut' }, 0.5);
    }
  }

  /* ---------- Pagina prodotto ---------- */

  function prodotto(scope) {
    var prod = scope.querySelector('[data-taste-product]');
    if (!prod || prod.dataset.tasteInit) return;

    var media = prod.querySelector('.product__media-wrapper');
    var info = prod.querySelectorAll('.product__info-container > *');

    // Sposto lo stato iniziale dal CSS agli stili inline dei soli nodi
    // presenti adesso: la regola CSS di nascondimento vale finché manca
    // data-taste-init, così i nodi che Dawn sostituisce al cambio variante
    // (es. variant-selects) restano visibili e non ereditano opacity: 0.
    if (media) gsap.set(media, { clipPath: 'inset(100% 0 0 0)' });
    if (info.length) gsap.set(info, { autoAlpha: 0, y: 18 });
    prod.dataset.tasteInit = 'true';

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    // La galleria si apre dal basso come una tenda.
    if (media) {
      tl.to(media, { clipPath: 'inset(0% 0 0 0)', duration: 1.1, clearProps: 'clipPath' }, 0);
    }

    // La colonna informazioni entra a scaletta. A fine corsa pulisco tutti
    // gli stili inline: sticky e layout tornano al CSS, e ora è sicuro
    // perché nessuna regola CSS nasconde più il contenuto inizializzato.
    if (info.length) {
      tl.to(
        info,
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.07,
          clearProps: 'transform,opacity,visibility'
        },
        0.2
      );
    }
  }

  /* ---------- Pagina carrello ---------- */

  function carrello(scope) {
    var contenitore = scope.querySelector('cart-items');

    if (contenitore && !contenitore.dataset.tasteInit) {
      var testa = contenitore.querySelectorAll('.title-wrapper-with-link > *, .cart__warnings > *');
      var intestazioni = contenitore.querySelector('.cart-items thead');
      var righe = contenitore.querySelectorAll('.cart-items tbody .cart-item');

      // Come per la pagina prodotto: sposto lo stato iniziale dal CSS agli
      // stili inline, poi marco l'init così le righe rimpiazzate da cart.js
      // non ereditano più opacity: 0 dalla regola CSS.
      if (testa.length) gsap.set(testa, { autoAlpha: 0, y: 16 });
      if (intestazioni) gsap.set(intestazioni, { autoAlpha: 0 });
      if (righe.length) gsap.set(righe, { autoAlpha: 0, y: 14 });
      contenitore.dataset.tasteInit = 'true';

      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      if (testa.length) {
        tl.to(testa, { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.08, clearProps: 'all' }, 0);
      }
      if (intestazioni) {
        tl.to(intestazioni, { autoAlpha: 1, duration: 0.5, clearProps: 'all' }, 0.15);
      }
      if (righe.length) {
        tl.to(righe, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.06, clearProps: 'all' }, 0.2);
      }
    }

    // Il riepilogo è una sezione a parte (main-cart-footer): entra dopo le righe.
    var footer = scope.querySelector('#main-cart-footer');
    if (footer && !footer.dataset.tasteInit) {
      var blocchi = footer.querySelectorAll('.cart__footer > *');
      if (blocchi.length) gsap.set(blocchi, { autoAlpha: 0, y: 16 });
      footer.dataset.tasteInit = 'true';

      if (blocchi.length) {
        gsap.to(blocchi, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.08,
          delay: 0.35,
          ease: 'power3.out',
          clearProps: 'all'
        });
      }
    }
  }

  /* ---------- Notifica di aggiunta al carrello ---------- */

  // Lo slide del pannello resta la transizione CSS di Dawn (il suo
  // transitionend gestisce il focus trap): qui aggiungo solo la scaletta
  // dei contenuti a ogni apertura, patchando open() una volta sola.
  function notifica() {
    if (window.__tasteNotificaPatch) return;
    window.__tasteNotificaPatch = true;

    customElements.whenDefined('cart-notification').then(function () {
      var Notifica = customElements.get('cart-notification');
      var openOriginale = Notifica.prototype.open;

      Notifica.prototype.open = function () {
        openOriginale.apply(this, arguments);

        if (!document.documentElement.classList.contains('gsap-motion')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var nodi = this.notification.querySelectorAll(
          '.cart-notification__header, .cart-notification-product, .cart-notification__links > *'
        );
        if (!nodi.length) return;

        gsap.fromTo(
          nodi,
          { autoAlpha: 0, y: 12 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.55,
            stagger: 0.06,
            delay: 0.12,
            ease: 'power3.out',
            overwrite: 'auto',
            clearProps: 'all'
          }
        );
      };
    });
  }

  /* ---------- Griglia: reinizializza i nodi sostituiti dai facet ---------- */

  function osservaGriglia() {
    var griglia = document.getElementById('ProductGridContainer');
    if (!griglia || griglia.dataset.tasteObserved) return null;
    griglia.dataset.tasteObserved = 'true';

    var pending = false;

    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Un solo re-init per raffica di mutazioni (i facet sostituiscono l'HTML in blocco).
      requestAnimationFrame(function () {
        pending = false;
        if (window.ThemeMotion && document.documentElement.classList.contains('gsap-motion')) {
          window.ThemeMotion.init(griglia);
        }
      });
    });

    observer.observe(griglia, { childList: true, subtree: true });

    return function () {
      observer.disconnect();
      delete griglia.dataset.tasteObserved;
    };
  }

  /* ---------- Avvio ---------- */

  // La patch della notifica va fatta una volta sola, fuori da matchMedia:
  // il rispetto di prefers-reduced-motion è verificato a ogni apertura.
  notifica();

  function init(scope) {
    scope = scope || document;

    mm.add(
      {
        anima: '(prefers-reduced-motion: no-preference)',
        riduci: '(prefers-reduced-motion: reduce)'
      },
      function (context) {
        // Motion ridotto: niente animazioni, contenuto già completo grazie al CSS.
        if (context.conditions.riduci) return;

        testata(scope);
        prodotto(scope);
        carrello(scope);
        var pulisci = osservaGriglia();

        return function () {
          if (pulisci) pulisci();
        };
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Nel customizer ogni sezione ricaricata viene rianimata.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Dawn sostituisce l'intero <product-info> quando il cambio variante porta
  // a un altro prodotto (combined listings): il nodo nuovo non è inizializzato
  // e va rianimato, altrimenti resterebbe nello stato iniziale del CSS.
  document.addEventListener('product-info:loaded', function (e) {
    if (!document.documentElement.classList.contains('gsap-motion')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    prodotto(e.target);
  });
})();
